(function () {
  'use strict'

  const MODULE_NAME = 'thismoment.common.formly.inputs.hidden'
  const templateUrl = require('./tpl/hidden.html')

  require('angular')
    .module(MODULE_NAME, [
      require('angular-formly'),
      require('angular-formly-templates-bootstrap')
    ])
    .run(hiddenConfig)

  hiddenConfig.$inject = ['formlyConfig']
  function hiddenConfig (formlyConfig) {
    formlyConfig.setType({
      name: 'hidden',
      templateUrl: templateUrl,
      controller: hiddenController,
      defaultOptions: {
        templateOptions: {
          type: 'hidden'
        }
      }
    })
  }

  hiddenController.$inject = ['$scope']
  function hiddenController ($scope) {
    // Store the original default value
    var originalValue = $scope.options.defaultValue || $scope.to.value

    // Set the initial value if not already set
    if (!$scope.model[$scope.options.key] && originalValue) {
      $scope.model[$scope.options.key] = originalValue
    }

    // Listen for form reset events and restore the hidden value
    $scope.$on('formly:resetForm', function () {
      // Restore the original value after form reset
      if (originalValue) {
        $scope.model[$scope.options.key] = originalValue
      }
    })

    // Also watch for model changes and restore if value gets cleared
    $scope.$watch('model.' + $scope.options.key, function (newValue) {
      if (!newValue && originalValue) {
        $scope.model[$scope.options.key] = originalValue
      }
    })
  }

  module.exports = MODULE_NAME
})()



// WEBPACK FOOTER //
// ./src/common/formly/inputs/hidden.js